import { t } from '@/features/i18n/utils';
import { ProcurementBreadcrumbs } from '@/features/subcontractor-bids/components/procurement-breadcrumbs';
import { createFileRoute } from '@tanstack/react-router';
import { Icon } from '@/ui/components/icon';
import { FolderIcon } from '@hugeicons-pro/core-stroke-rounded';
import { BreadcrumbLink, BreadcrumbPage } from '@/ui/components/breadcrumb';
import { Header, HeaderBackButton, HeaderChatButton } from '@/ui/components/header';
import {
  FilesDetailPageBreadcrumbPage,
  FilesDetailPage,
} from '@/features/documents/components/files-page/files-detail-page';
import { documentVersionsQuery } from '@/features/documents/queries';

export const Route = createFileRoute(
  '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/files/$documentId',
)({
  component: RouteComponent,
  loader: ({ context, params }) =>
    context.queryClient.query({ ...documentVersionsQuery(params.documentId), staleTime: 'static' }),
});

function RouteComponent() {
  const { projectId, workspaceId, procurementId, documentId } = Route.useParams();

  return (
    <>
      <Header>
        <HeaderBackButton />
        <ProcurementBreadcrumbs>
          <BreadcrumbLink
            to="/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/files"
            params={{ projectId, workspaceId, procurementId }}
          >
            <Icon icon={FolderIcon} />
            {t({ en: 'Files', nb: 'Filer' })}
          </BreadcrumbLink>
          <BreadcrumbPage>
            <FilesDetailPageBreadcrumbPage documentId={documentId} />
          </BreadcrumbPage>
        </ProcurementBreadcrumbs>
        <HeaderChatButton />
      </Header>
      <FilesDetailPage documentId={documentId} />
    </>
  );
}
